<template>
  <button
      class="btn btn-xs mr-5" :class="'btn-' + btnStyle"
      :title="title"
      @click="$emit('click', $event)"
  >
    <slot></slot>
  </button>
</template>

<script>
   import { ref, watch, onMounted, nextTick } from 'vue'
   export default {
      name: "s-button",
      props: {
         title: String,
         btnStyle: String // primary, danger, ...
      },
      setup(props){
         const el = ref(null)
         const initTooltip = () => {
         }
         watch(
            () => props.title,
            async () => {
            await nextTick()
            }
         )
         onMounted(initTooltip)
         return {el}
      }
   }
</script>
